<template>
  <div class="video-page">
    <el-card class="mt20">
      <div class="common-page common-head">
        <div class="common-page common-head-title">
          <i class="icon-tr--detailed" style="padding-right: 5px"></i>
          单位报告管理
        </div>
      </div>
      <div class="ml20 f18 blue">
        <span class="cursor" @click="goBack()">
          <i class="el-icon-back cursor"></i>
          返回
        </span>
      </div>
      <div class="f-right ">
        <div class="flex1"></div>

        <el-button
          v-hasPermi="['wenwu:report:query']"
          icon="el-icon-search"
          type="primary"
          @click="showdia2 = true"
        >
          查询
        </el-button>
        <el-button
          v-hasPermi="['wenwu:report:add']"
          icon="el-icon-plus"
          type="primary"
          @click="add"
          >新增</el-button
        >
      </div>
      <el-table :data="list" style="margin-top: 40px;">
        <el-table-column
          prop="num"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="bg_company_name"
          label="单位名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="bg_company_address"
          align="center"
          label="单位地址"
        ></el-table-column>
        <el-table-column
          prop="bg_company_hangye"
          align="center"
          label="行业"
        ></el-table-column>
        <el-table-column
          prop="bg_new_time"
          align="center"
          label="最新报告上传时间"
        ></el-table-column>
        <el-table-column
          prop="bg_suoshu_area"
          align="center"
          label="所属地区"
        ></el-table-column>

        <!-- <el-table-column align="center" label="文件上传">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="add(scope.row, 1)">
			  文件上传
			  </el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" width="160px">
          <template slot-scope="scope">
            <router-link
              :to="{
                path: '/report/detail-list',
                query: { id: scope.row.bg_company_num },
              }"
              v-hasPermi="['wenwu:report:detail']"
            >
              <el-button type="primary" size="mini">详情</el-button>
            </router-link>
            <el-button
              v-hasPermi="['wenwu:report:add']"
              type="warning"
              size="mini"
              @click="update(scope.row)"
            >
              新增
            </el-button>

            <el-popconfirm
              title="确定执行此操作吗？"
              class="cursor"
              @onConfirm="changeStatus(scope.row)"
              @confirm="changeStatus(scope.row)"
              v-hasPermi="['wenwu:report:remove']"
            >
              <a slot="reference"
                ><el-button type="danger" size="mini">删除</el-button></a
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        class="mt20 tx-center"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-size="10"
        layout="prev, pager, next, jumper"
        :total="count"
      ></el-pagination>
    </el-card>

    <el-dialog
      :title="status == 1 ? '文件上传' : '修改'"
      :before-close="beforeClose"
      :visible.sync="showDia"
      :width="status == 1 ? '830px' : '500px'"
      ref="model"
      :close-on-click-modal="false"
    >
      <el-row :gutter="30" v-if="status == 1" v-loading="loading1">
        <el-col :span="13">
          <el-form
            :model="form"
            :rules="rules"
            ref="form"
            label-width="80px"
            size="small"
          >
            <el-form-item label="单位名称" prop="basebg.bg_company_num">
              <el-select
                :disabled="isread"
                v-model="form.basebg.bg_company_num"
                filterable
                remote
                placeholder="请输入关键词"
                :loading="sloading"
              >
                <el-option
                  v-for="item in compList"
                  :key="item.c_company_num"
                  :label="item.c_name"
                  :value="item.c_company_num"
                ></el-option>
              </el-select>
              <!-- <el-button size="mini" @click="addUnit">新增社会单位</el-button> -->
            </el-form-item>
            <el-form-item
              label="项目名称"
              v-if="false"
              prop="xiangmubg.xm_suoshu"
            >
              <!-- <el-input v-model="form.xiangmubg.xm_suoshu"></el-input> -->

              <el-select
                :disabled="isread"
                v-model="form.xiangmubg.xm_suoshu"
                filterable
                remote
                placeholder="请输入关键词"
                :loading="sloading"
              >
                <el-option
                  v-for="item in programList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="报告名称" prop="xiangmubg.xm_baogao_name">
              <el-input v-model="form.xiangmubg.xm_baogao_name"></el-input>
            </el-form-item> -->
            <el-form-item label="报告类型" prop="xiangmubg.xm_baogao_leixing">
              <el-select
                v-model="form.xiangmubg.xm_baogao_leixing"
                filterable
                clearable
              >
                <el-option
                  :label="item.mc_name"
                  :value="item.mc_id"
                  v-for="item in randomList"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="生成日期" prop="basebg.starttime">
              <el-date-picker
                v-model="form.basebg.starttime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="检查人员"
              v-if="false"
              prop="xiangmubg.xm_jiancha_user"
            >
              <!-- <el-input :value="tr_address" ></el-input>
               -->

              <!-- <el-select multiple="" v-model="form.tr_per">
                
               </el-select> -->
              <el-input v-model="form.xiangmubg.xm_jiancha_user"> </el-input>
            </el-form-item>
            <el-form-item label="选择文件" prop="wenjianbg">
              <el-upload
                drag
                action="."
                :http-request="upload"
                multiple
                list-type="none"
                :before-upload="beforeUpload"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="11">
          <el-card class="upload-box">
            <el-scrollbar style="height: 440px">
              <ul class="file-list">
                <li v-for="item in fileList" class="align-center">
                  <img src="@/assets/img/base.png" alt="" />
                  <div class="flex1">
                    <div class="mb5" :title="item.name">{{ item.name }}</div>
                    <div class="mb5">
                      {{ (item.size / 1024 / 1024).toFixed(2) }}M
                    </div>
                    <el-progress
                      :percentage="+item.progress.toFixed(1)"
                    ></el-progress>
                  </div>
                  <i class="el-icon-close" @click="closeFile(item)"></i>
                </li>
              </ul>
            </el-scrollbar>
          </el-card>
        </el-col>
      </el-row>

      <!-- <el-form
        :model="editForm"
        :rules="rules1"
        ref="form1"
        label-width="80px"
        size="small"
        v-else
        v-loading="loading1"
      >
        <el-form-item label="单位名称">
          <el-input v-model="tr_address" disabled></el-input>
        </el-form-item>
        <el-form-item label="项目名称" prop="tr_project_name">
          <el-select
            v-model="editForm.tr_project_name"
            filterable
            remote
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            @change="changeS"
            :loading="sloading"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.unit_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报告名称">
          <el-input v-model="tr_address" disabled></el-input>
        </el-form-item>
        <el-form-item label="报告类型" prop="tr_undertaker">
          <el-select v-model="editForm.tr_undertaker">
            <el-option
              :label="item.tr_user_name"
              :value="item.tr_user_id"
              v-for="item in userList"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报告生成日期" prop="tr_assist">
          <el-select v-model="editForm.tr_assist">
            <el-option
              :label="item.tr_user_name"
              :value="item.tr_user_id"
              v-for="item in userList"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form> -->

      <div class="center">
        <el-button
          type="primary"
          @click="formSubmit"
          size="small"
          :loading="isUpload"
          >提交</el-button
        >
        <!-- -->

        <el-button
          @click="
            beforeClose(() => {
              showDia = false;
            })
          "
          size="small"
        >
          取消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="查询" :visible.sync="showdia2">
      <el-form label-width="100px" size="small" class="flex1">
        <el-form-item label="单位名称">
          <!-- <el-input v-model="params.bg_company_name" clearable></el-input> -->
          <el-select
            :disabled="isread"
            v-model="params.bg_company_name"
            filterable
            remote
            placeholder="请输入关键词"
            :loading="sloading"
          >
            <el-option
              v-for="item in compList"
              :key="item.c_company_num"
              :label="item.c_name"
              :value="item.c_company_num"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属行业">
          <el-select
            v-model="params.bg_company_hangye"
            filterable
            clearable
            no-match-text=" "
          >
            <el-option
              :label="item.mc_name"
              :value="item.mc_id"
              v-for="item in hangye"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属地区" prop="tr_type">
          <el-col :span="7">
            <el-select
              placeholder="省"
              clearable
              v-model="params.bg_suoshu_sheng"
              @change="getCitys('shi')"
            >
              <el-option
                v-for="item in sheng"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              ></el-option>
            </el-select>
          </el-col>
          <el-col class="ml20" :span="7">
            <el-select
              placeholder="市"
              clearable
              v-model="params.bg_suoshu_shi"
              @change="getCitys('qu')"
            >
              <el-option
                v-for="item in shi"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              ></el-option>
            </el-select>
          </el-col>
          <el-col class="ml20" :span="7">
            <el-select placeholder="区" clearable v-model="params.bg_suoshu_qu">
              <el-option
                v-for="item in qu"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="开始时间" prop="tr_base.tr_time">
          <el-date-picker
            v-model="params.starttime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="tr_base.tr_time">
          <el-date-picker
            v-model="params.endtime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div class="center">
        <el-button
          type="primary"
          @click="searchSubmit"
          size="small"
          :loading="isUpload"
          >提交</el-button
        >
        <el-button @click="reset" size="small">取消</el-button>
      </div>
    </el-dialog>
    <!-- <unit v-show="false" ref="unit" isson="1"></unit> -->
  </div>
</template>

<script>
// import {
//   getList,
//   getDetail,
//   add,
//   edit,
//   getVideo,
//   editVideo,
// } from "../../api/media.js";
// import {
//   getUser,
//   getLaw,
//   getRandom,
//   getSociety,
//   getUnit,
// } from "../../api/common";
import OSS from "ali-oss";
export default {
  data() {
    return {
      showdia2: false,
      editData: {
        tr_random_id: "",
        tr_type: "",
        tr_status: 3,
        tr_name: "",
        tr_length: 0,
      },
      params: {
        page: 1,
        bg_company_name: "",
        num: "",
        bg_company_hangye: "",
        bg_suoshu_sheng: "",
        bg_suoshu_shi: "",
        bg_suoshu_qu: "",
        starttime: "",
        endtime: "",
      },
      loading1: false,
      sloading: false,
      isread: false,
      tr_address: "",
      status: 1, //1新增 2修改
      count: 0,
      showDia: false,
      searchForm: {
        tr_project_name: "",
        //tr_undertaker:'',
        tr_unit: "",
        tr_type: "",
      },

      form: {
        basebg: {
          bg_company_num: "",
          starttime: "",
        },
        xiangmubg: {
          xm_baogao_leixing: "",
          xm_suoshu: "",
          xm_jiancha_user: "",
        },
        wenjianbg: [],
      },
      rules: {
        "basebg.bg_company_num": [
          { required: true, message: "请选择单位", trigger: "blur" },
        ],
        "xiangmubg.xm_suoshu": [
          { required: true, message: "请选择所属项目", trigger: "blur" },
        ],
        // wenjianbg: [{ required: true, message: '请上传文件', trigger: 'blur' }],
        "xiangmubg.xm_baogao_leixing": [
          { required: true, message: "请选择类型", trigger: "blur" },
        ],

        "xiangmubg.xm_jiancha_user": [
          { required: true, message: "请填写检查人员", trigger: "blur" },
        ],
        "basebg.starttime": [
          { required: true, message: "请选择日期", trigger: "blur" },
        ],
      },

      list: [],
      editForm: {
        tr_project_name: "",
        tr_undertaker: "", //承办人
        tr_assist: "", //协办人
        tr_id: "",
        tr_is_case: "",
        tr_status: 2,
        tr_unit_num: "",
        tr_type: "",
      },
      sheng: [],
      shi: [],
      qu: [],
      hangye: [],
      userList: [],
      fileList: {},
      // lawList: [],
      // unitList: [],
      // userList_s: [],
      randomList: [],
      programList: [],
      // projectList: [],
      compList: [],
      canEditLength: false,
      loading: false,
      prevRoute: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log(from,'from');
      if (vm.$store.state.user.userInfo.natureId == 2) {
        vm.$router.push({
          path: "/report/detail-list",
          query: { id: vm.$store.state.user.company.cCompanyNum },
        });
      }else if (from.fullPath.indexOf('id')>-1) {
          vm.prevRoute = from.fullPath
      }else{
        vm.prevRoute = from.path
      }
     
    
    });
  },
  created() {
    this.getList();
    this.getCitys("sheng");
    // 获取所有社会单温
    this.$post("/dzda/allbase").then((res) => {
      this.compList = res.data;
    });
    this.$get("/trxf/main/sys/area/arealist").then((res) => {});
    // 查询报告类型
    this.$post("/devicemanage/mapcode", { mc_parent_id: 232 }).then((res) => {
      console.log(res, 2222222222222222);
      this.randomList = res.data;
    });
    // 查询省

    this.$post("/devicemanage/mapcode", { mc_parent_id: 66 }).then((res) => {
      this.hangye = res.data;
    });
    // 项目列表
    this.$post("/dzda/allxiangmu", this.params).then((res) => {
      this.programList = res.data;
    });
  },
  methods: {
    goBack() {
      // 返回上一页
      this.$router.push(this.prevRoute)
    },
    delVideo(it) {
      //删除视频
      editVideo({ tr_id: it.tr_id, tr_status: 0 }).then((res) => {
        this.$message({
                message: '修改成功',
                type: 'success',
                duration: 700,
              });
        // this.$message.success("修改成功");
        this.getVideoData();
        this.getList();
      });
    },
    changeStatus(it, del) {
      this.$post("/dzda/delbasebg", {
        bg_uuid: it.bg_uuid,
      }).then((res) => {
        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        // this.$message.success("操作成功");
        this.getList();
      });
    },
    addUnit() {
      this.$router.push("/company/company-add");
    },
    changeUnit(val) {
      this.userList_s = [];
      getUser(val).then((res) => {
        this.userList_s = res.data || [];
      });
    },

    //  获取城市
    getCitys(name) {
      var url = "bg_suoshu_sheng";
      var Name = "bg_suoshu_shi";
      switch (name) {
        case "sheng":
          break;
        case "shi":
          url = "bg_suoshu_sheng";
          this.params.bg_suoshu_shi = "";
          this.params.bg_suoshu_qu = "";

          break;
        case "qu":
          url = "bg_suoshu_shi";
          Name = "bg_suoshu_qu";
          this.params.bg_suoshu_qu = "";

          break;
        default:
          false;
      }

      this.$post(`/dzda/${name}`, { area_code: this.params[url] || "" }).then(
        (res) => {
          this[name] = res.data;
        }
      );
    },
    reset() {
      this.resetSearch();
      this.getList();

      this.showdia2 = false;
    },
    down(it) {
      //   if (it.tr_href.indexOf("aliyuncs.com") != -1) {
      //     var url = it.tr_href.split("?")[0];
      //     download(url, it.tr_name + ".flv");
      //   } else {
      //     let client = new OSS(this.$store.state.config.ossConfig);
      //     let url = client.signatureUrl(it.tr_href);
      //     if (it.tr_href.indexOf("?up") != -1) {
      //       url = it.tr_href.split("?")[0];
      //     }
      //     download(url, it.tr_name);
      //   }

      if (it.is_oss == 1 && it.tr_href.indexOf("aliyuncs.com") != -1) {
        var url = it.tr_href.split("?")[0];
        download(url, it.tr_name + ".flv");
      } else if (it.is_oss) {
        var tr_local_href = it.tr_local_href;
        let client = new OSS(this.$store.state.config.ossConfig);
        let client2 = new OOS.S3(this.$store.state.config.oosConfig);
        if (it.is_oss == 2) {
          if (tr_local_href.indexOf("/") == 0) {
            tr_local_href = tr_local_href.substring(1, tr_local_href.length);
          }
        }

        url =
          it.is_oss == 1
            ? client.signatureUrl(fileid)
            : client2.getSignedUrl("getObject", {
                Bucket: "sdtongren",
                Key: tr_local_href,
              });

        log(url);
        // let url = client.signatureUrl(it.tr_href);
        // if (it.tr_href.indexOf("?up") != -1) {
        //   url = it.tr_href.split("?")[0];
        // }
        download(url, it.tr_name);
      } else if (!it.is_oss) {
        // 下载 线下
        var url = `${this.$store.state.config.miniUrl}${it.tr_local_href}`;
        console.log(url);
        download(url, it.tr_name);
      }
    },
    resetSearch() {
      this.params = {
        page: 1,
        bg_company_name: "",
        bg_company_hangye: "",
        bg_suoshu_sheng: "",
        bg_suoshu_shi: "",
        bg_suoshu_qu: "",
        starttime: "",
        endtime: "",
      };
      this.params = { ...this.params };
    },
    beforeUpload(file) {
      // let testmsg = /^video\/(mp4|webm|ogg|ogv)$/.test(file.type)
      // if (!testmsg) {
      //     this.$message.error('暂不支持此视频格式上传!')
      //     return false
      // }
    },
    // changeS(val) {
    //   this.projectList.forEach((it) => {
    //     if (it.id === val) {
    //       this.tr_address = it.unit_address;
    //     }
    //   });
    // },
    play(it) {
      this.$refs.video.open = true;
      var type = null;

      if (it.is_oss && it.is_oss == 1) {
        var name = it.tr_href.split("?")[0];
        if (/^.*\..*$/.test(name)) {
          type = name.split(".")[name.split(".").length - 1];
        }
        this.$refs.video.getDownUrl(
          it.tr_href,
          null,
          type,
          it.tr_length,
          it.is_oss
        );
      } else {
        var name = it.tr_href.split("?")[0];

        if (/^.*\..*$/.test(name)) {
          type = name.split(".")[name.split(".").length - 1];
        }
        this.$refs.video.getDownUrl1(
          it.tr_local_href,
          null,
          type,
          it.tr_length,
          it.is_oss
        );
      }
    },
    // remoteMethod(query) {
    //   if (query !== "") {
    //     this.sloading = true;
    //     getSociety(query).then((res) => {
    //       this.sloading = false;
    //       this.projectList = res.data;
    //     });
    //   } else {
    //     this.projectList = [];
    //     this.sloading = false;
    //   }
    // },
    beforeClose(done) {
      if (this.isUpload) {
        this.$confirm("文件上传中，关闭将取消上传，是否取消", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            done();
            this.cancleUpload();
          })
          .catch(() => {});
      } else {
        done();
      }
    },

    cancleUpload() {
      this.fileList = {};
      this.form = {
        basebg: {
          bg_company_num: "",
        },
        xiangmubg: {
          xm_baogao_leixing: "",
          xm_suoshu: "",
          xm_jiancha_user: "",
        },
        wenjianbg: [],
      };
    },
    update(it) {
      this.form.basebg.bg_company_num = it.bg_company_num;
      this.showDia = true;
    },
    changeCase(it) {
      //改变立案状态
      let obj = {
        tr_is_case: it.tr_is_case,
        tr_id: it.tr_id,
      };
      edit(obj)
        .then((res) => {
          // this.$message.success("修改是否立案成功");
          this.$message({
                message: '修改是否立案成功',
                type: 'success',
                duration: 700,
              });
        })
        .catch((err) => {});
    },
    closeFile(it) {
      //取消上传
      it.client.cancel();
      this.$delete(this.fileList, it.key);
    },
    getList() {
      this.loading = true;
      this.$post("/dzda/listbase", this.params).then((res) => {
        this.list = res.data.list;
        this.count = res.data.count;
        this.loading = false;
      });
      setTimeout(() => {
        if (this.list.length == 0 && this.loading == true) {
          this.loading = false;
          this.$message.error("请求失败,请重试");
        }
      }, 60000);
    },

    upload(val) {
      if (
        !(
          val.file.name.indexOf("doc") > -1 ||
          val.file.name.indexOf("docx") > -1 ||
          val.file.name.indexOf("pdf") > -1 ||
          val.file.name.indexOf("jpg") > -1 ||
          val.file.name.indexOf("png") > -1 ||
          val.file.name.indexOf("jpeg") > -1
        )
      ) {
        this.$notify({
          title: "暂不支持该文件类型",
          // message: `${_this.fileList[id].name}上传完成`,
          type: "warning",
        });

        return;
      }

      let file = val.file;
      let id =
        // "/common/upload" +
        // // this.$config.dangan +
        // "/t" +
        Date.now() + "s" + file.size + "/" + file.name;
      this.$set(this.fileList, id, {
        name: file.name,
        size: file.size,
        uploading: true,
        time: 0,
        progress: 0,
        key: id,
        url: "",
        // client: client,
      });
      log(this.fileList, "111111111111111111111");
      this.getTimes(file, id);

      let formData = new FormData();
      console.log(formData, "formData");
      formData.append("file", file);
      console.log(formData, "formData1");
      // formData.append("title", this.title);
      this.getTimes(file, id);
      console.log(file, "file");

      this.$post("/common/upload", formData).then((res) => {
        this.fileList[id].progress = 100;
        this.fileList[id].uploading = false;
        this.fileList[id].url = res.data.url;
        //   this.$set(this.fileList, id, {
        //   key: res.data.url,

        log(this.fileList, res, "res");
        // this.fileList.key=res.data.url
        this.$notify({
          title: "上传成功",
          message: `${this.fileList[id].name}上传完成`,
          type: "success",
        });
      });

      // this.$set(this.fileList, id, {
      //   name: file.name,
      //   size: file.size,
      //   uploading: true,
      //   time: 0,
      //   progress: 0,
      //   key: id,
      //   client: client,
      // });
      // _this.getTimes(file, id);
      // console.log(_this.fileList[id]);
      // // 定义上传方法。
      // function multipartUpload() {
      //   _this.fileList[id].client
      //     .multipartUpload(id, file, {
      //       checkpoint: _this.fileList[id] ? _this.fileList[id].data : null,
      //       progress: (p, checkpoint, res) => {
      //         //log(p,checkpoint,res)
      //         if (checkpoint) {
      //           _this.fileList[id].progress = p * 100;
      //           _this.fileList[id].data = checkpoint;
      //         }
      //       },
      //       partSize: 1000 * 1024, //设置分片大小
      //       timeout: 120000, //设置超时时间
      //       mime: val.type,
      //     })
      //     .then((res) => {
      //       _this.fileList[id].progress = 100;
      //       _this.fileList[id].uploading = false;
      //       console.log(res);
      //       _this.$notify({
      //         title: '上传成功',
      //         message: `${_this.fileList[id].name}上传完成`,
      //         type: 'success',
      //       });
      //     })
      //     .catch((err) => {
      //       if (err.code == 'RequestError' || err.code == 'ConnectionTimeoutError') {
      //         //网络错误或超时
      //         setTimeout(multipartUpload, 3000);
      //       }
      //     });
      // }
      // this.rules.wenjianbg = [];
      // multipartUpload();
    },

    //     upload(val) {
    //   log(val);

    //   let client = new OOS.S3(this.$store.state.config.oosConfig);
    //   let file = val.file;
    //   var cls =  file.name.substring(file.name.lastIndexOf('.'),file.name.length)
    //   let id =this.$config.upload2 + Date.now()+(  Math.floor(Math.random() * (100 - 1)) + 1) + "s" + cls;

    //   let _this = this;
    //   this.$set(this.fileList, id, {
    // name: file.name,
    //     size: file.size,
    //     uploading: true,
    //     chunk: 0,
    //     isLastChunk: false,
    //     time: 0,
    //     chunkSize:10,
    //     progress: 0,
    //     key: id,
    //     client: client,
    //   });
    //   _this.getTimes(file, id);

    //   function multipartUpload() {

    //       var MultipartUpload = [];
    //     _this.fileList[id].client.createMultipartUpload(
    //       {
    //         Bucket: "sdtongren",
    //         Key: id,
    //       },
    //       function (err, data) {
    //         if (err) {
    //           console.log(err);
    //         } else {
    //           console.log(data);
    //           _this.fileList[id].UploadId = data.UploadId
    //           chuncksfile(data, MultipartUpload);
    //         }
    //       }
    //     );
    //   }
    //    function chuncksfile(data, MultipartUpload) {
    //     let chuncklength = 0;
    //     console.log(file.size);
    //     if (file.size > 1024 * 1024 * _this.fileList[id].chunkSize) {
    //       chuncklength = Math.ceil(file.size / (1024 * 1024 * _this.fileList[id].chunkSize)); // 文件大小大于10mb 转换成了字节
    //       console.log(chuncklength);
    //     } else {
    //       chuncklength = 1;
    //     }
    //     _this.fileList[id].chunk === chuncklength - 1
    //       ? (_this.fileList[id].isLastChunk = true)
    //       : false; // 当前已经传好的片数
    //     var Body = file.slice(
    //       _this.fileList[id].chunk * 1024 * 1024 * _this.fileList[id].chunkSize,
    //       (_this.fileList[id].chunk + 1) * 1024 * 1024 * _this.fileList[id].chunkSize
    //     ); // 分片上传的文件
    //     data.PartNumber = _this.fileList[id].chunk + 1; // 分片唯一标识
    //     data.Body = Body;
    //     data.ContentLength = chuncklength;
    //     console.log("开始上传");

    //     _this.fileList[id].client.uploadPart(data, function (error, res) {
    //       console.log(error);
    //       if (error) {
    //         console.log("上传失败");
    //         if(_this.isUpload && _this.showDia){
    //           chuncksfile(data, MultipartUpload);

    //         }
    //         return false;
    //       } else {
    //         console.log(_this.isUpload)
    //           if(!_this.isUpload) return
    //         _this.fileList[id].chunk++; // 上传的片数递增
    //         MultipartUpload.push({
    //           PartNumber: data.PartNumber,
    //           ETag: res.ETag,
    //         }); // 存储已经上传额分片信息

    //         var pr = parseInt(
    //           ((_this.fileList[id].chunk + 1) / chuncklength) * 100
    //         );
    //         console.log(pr);
    //         if (pr > 100) pr = 100;
    //         _this.fileList[id].progress = pr;
    //         if (_this.fileList[id].isLastChunk) {
    //           console.log(MultipartUpload);
    //           console.log("上传完成");

    //           var ob = {};
    //           ob.Bucket = data.Bucket;
    //           ob.Key = data.Key;
    //           ob.UploadId = data.UploadId;
    //           ob.MultipartUpload = { Parts: MultipartUpload };
    //           // 合并分片文件 完成一次分片上传
    //           client.completeMultipartUpload(ob, function (er, data) {
    //             if (data) {
    //               console.log("上传成功了");
    //               _this.$notify({
    //                 title: "上传成功",
    //                 message: `${_this.fileList[id].name}上传完成`,
    //                 type: "success",
    //               });
    //               _this.fileList[id].uploading = false;
    //             } else {
    //               console.log("出错了" + er);
    //             }
    //           });
    //         } else {
    //           // 未上传完成
    //           chuncksfile(data, MultipartUpload);
    //         }
    //       }
    //     });
    //   }
    //   multipartUpload();
    // },

    getTimes(file, id) {
      //获取时长
      let content = file;
      let url = URL.createObjectURL(content);
      let audioElement = new Audio(url);
      let time;
      let _this = this;
      audioElement.addEventListener("loadedmetadata", (_event) => {
        if (!_this.fileList[id].time) {
          this.audioDuration = parseInt(audioElement.duration);
          time = this.audioDuration;
          _this.$set(_this.fileList[id], "time", time);
        }
      });
    },
    handleCurrentChange1(page) {
      this.video_params.page = page;
      this.getVideoData();
    },
    edit(it) {
      this.status = 2;
      getDetail(it.tr_id)
        .then((res) => {
          this.showDia = true;
          this.loading1 = false;
          let data = res.data;
          this.tr_address = it.tr_address;
          this.editForm.tr_project_name = data.tr_project_name;
          this.editForm.tr_undertaker = data.tr_undertaker;
          this.editForm.tr_assist = data.tr_assist;
          this.editForm.tr_id = data.tr_id;
          this.editForm.tr_type = data.tr_type;
          this.editForm.tr_unit_num = data.tr_unit_num;
          this.remoteMethod(it.tr_project_name);
        })
        .catch(() => {
          this.loading1 = false;
        });
    },
    add(it, type) {
      this.isread = false;
      this.status = 1;
      this.showDia = true;
      if (type) {
        this.isread = true;
        this.loading1 = true;
        getDetail(it.tr_id)
          .then((res) => {
            let data = res.data;
            this.loading1 = false;
            this.tr_address = it.tr_address;
            this.form.tr_base.tr_project_name = data.tr_project_name;
            this.form.tr_base.tr_undertaker = data.tr_undertaker;
            this.form.tr_base.tr_assist = data.tr_assist;
            this.form.tr_base.tr_id = data.tr_id;
            this.form.tr_base.tr_type = data.tr_type;
            this.remoteMethod(it.tr_project_name);
          })
          .catch(() => {
            this.loading1 = false;
          });
      }
    },
    del(it) {
      let obj = { tr_status: 0, tr_id: it.tr_id };
      edit(obj).then((res) => {
        this.$message.success("删除成功");
        this.getList();
      });
    },
    handleCurrentChange(page) {
      this.params.page = page;
      this.getList();
    },
    searchSubmit() {
      this.params.page = 1;
      this.params = { ...this.params };
      this.getList();
      this.showdia2 = false;
      // this.rules.wenjianbg.clearValidate();
    },
    // editVideo(it) {
    //   //修改视频
    //   if (it) {
    //     this.showEdit = true;
    //     console.log(it);
    //     this.editData.tr_id = it.tr_id;
    //     this.editData.tr_type = it.get_type.tr_id;
    //     this.editData.tr_random_id = it.tr_random;
    //     this.editData.tr_name = it.tr_name;

    //     if (it.tr_length == "0" || it.tr_length == null || it.tr_length < 6) {
    //       this.editData.tr_length = "";
    //       this.canEditLength = true;
    //     } else {
    //       this.editData.tr_length = it.tr_length;
    //       this.canEditLength = false;
    //     }
    //     this.randomList.forEach((item) => {
    //       if (it.tr_random_id == item.tr_random_id) {
    //         this.editData.tr_random_id = it.tr_random_id;
    //       }
    //     });
    //     log(this.editData);
    //     //this.editData.tr_random_id = it.tr_random_id
    //   } else {
    //     let editData = { ...this.editData };
    //     if (!+this.editData.tr_random_id) {
    //       delete editData.tr_random_id;
    //     }
    //     if (editData.tr_length) {
    //       var tr_length = editData.tr_length;
    //       if (tr_length.indexOf(":") != -1) {
    //         tr_length = tr_length.split(":");
    //       } else if (tr_length.indexOf("：") != -1) {
    //         tr_length = tr_length.split("：");
    //       } else {
    //         tr_length = [tr_length];
    //       }
    //       switch (tr_length.length - 0) {
    //         case 2:
    //           editData.tr_length = tr_length[0] * 60 + Number(tr_length[1]);
    //           break;
    //         case 3:
    //           editData.tr_length =
    //             tr_length[0] * 3600 + tr_length[1] * 60 + Number(tr_length[2]);
    //           break;
    //       }
    //     }
    //     this.isUpload = true;
    //     editVideo(editData)
    //       .then((res) => {
    //         this.isUpload = false;
    //         this.$message.success("修改成功");
    //         this.getVideoData();
    //         this.getList();
    //         this.editData.tr_random_id = "";
    //         this.editData.tr_type = "";
    //         this.showEdit = false;
    //       })
    //       .catch((err) => {
    //         this.isUpload = false;
    //       });
    //   }
    // },
    formSubmit() {
      let _this = this;

      if (this.status === 1) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            console.log("jixu");
            for (let key in this.fileList) {
              let data = this.fileList[key];
              console.log(data);
              this.form.wenjianbg.push({
                wj_name: data.name,
                wj_lujing: data.url,
              });
            }
            let params = this.form;
            // this.isUpload = true;
            this.$post("/dzda/addbasebaogao", params).then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message.success(res.msg || "操作成功");
                this.showDia = false;
                this.cancleUpload();
                this.getList();
              }
            });
          } else {
            return false;
          }
        });
      } else {
        //修改
        edit(this.editForm).then((res) => {
          this.$message({message: res.msg,type: "success", duration: 700,});
          this.showDia = false;
          this.getList();
        });
      }
    },
  },
  watch: {},
  computed: {
    isUpload() {
      for (let i in this.fileList) {
        if (this.fileList[i].uploading) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.file-list {
  li {
    position: relative;
    padding: 20px 10px;
    border-bottom: 1px solid #eee;

    img {
      width: 75px;
      margin-right: 15px;
    }

    .el-icon-close {
      position: absolute;
      right: 20px;
      top: 8px;
      cursor: pointer;
    }
  }
}
.el-card {
  box-shadow: 0 0 0 0;
  border: none;
}
.mb5 {
  margin-bottom: 5px;
}

.ml20 {
  margin-left: 20px;
}
.mt10 {
  margin-top: 10px !important;
}
</style>
